import PropTypes from 'prop-types'

export const eventMessagePropType = PropTypes.shape({
    params: PropTypes.objectOf(PropTypes.string),
    text: PropTypes.string,
    type: PropTypes.string
})
